module.exports = __webpack_public_path__ + "7ac23d26e1140e5b3753899319831bc5.png";